export enum IconsEnum {
  NONE = 'none',
  CROSS = 'cross',
  CHAT_CLIP = 'chat-clip',
  SEND = 'send',
  CHECKBOX = 'checkbox',
  WIDGET_ARROW_LEFT = 'widget-arrow-left',
  WIDGET_ARROW_RIGHT = 'widget-arrow-right',
  PLUS = 'plus',
  TICK = 'tick',
}
